import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination';
import "swiper/css/navigation";
import { Autoplay, Navigation } from 'swiper'

import './styles/Home.scss'
import { useAppSelector } from '../redux/hooks';
import ProductCard from '../components/ProductCard/ProductCard';


const Home = () => {
  const products = useAppSelector((state) => state.productReducer)
  const newProducts = products.slice(10, 22)
  const pagination = {
    clickable: true,
    renderBullet: (index: number, className: string) => {
      return '<span class="' + className + '">' + (index + 1) + "</span>"
    }
  }
  return (
    <main>
      <section>
        <div className="container">
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={pagination}
            className="slider"
          >
            <SwiperSlide>
              <div className="image">
                <img src={process.env.PUBLIC_URL + '/slider.png'} alt="" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="image">
                <img src={process.env.PUBLIC_URL + '/slider.png'} alt="" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      <section>
          <div className="new-products">
          <div className="container container-overflow">
              <div className="best-items">
                <h2>New Products</h2>
                <Swiper
                  modules={[Navigation]}
                  spaceBetween={0}
                  slidesPerView={6}
                  className="slider"
                  navigation={true}
                >
                  {newProducts.map(item => 
                    <SwiperSlide key={item.id}>
                      <ProductCard product={item}/>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
            </div>
          </div>
      </section>
    </main>
  )
}

export default Home